(function () {
'use strict';
var CFG = window.ComboCartConfig || {};
var UI = CFG.ui || {};
if (typeof UI === 'string') { try { UI = JSON.parse(UI); } catch (e) { UI = {}; } }
if (!UI || typeof UI !== 'object') UI = {};
var L = window.CCLib = {};
L.CFG = CFG;
L.UI = UI;
L.ROOT = (CFG.root || '/').replace(/\/?$/, '/');
L.readSettings = function (scope) {
var el = (scope || document).querySelector('script[data-cc-settings]');
if (!el) return false;
try {
var s = JSON.parse(el.textContent);
Object.keys(s).forEach(function (k) { UI[k] = s[k]; });
return true;
} catch (e) { return false; }
};
L.readSettings();
L.T = function (key, def) { var v = UI[key]; return (v == null || v === '') ? def : String(v); };
L.on = function (key, def) { var v = UI[key]; return v == null ? def : !!v; };
L.ICON_CART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>';
L.ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
L.ICON_TAG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.4 11.6l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7c0 .6.2 1.1.6 1.4l9 9a2 2 0 0 0 2.8 0l7-7a2 2 0 0 0 0-2.8zM6.5 8A1.5 1.5 0 1 1 6.5 5a1.5 1.5 0 0 1 0 3z"/></svg>';
L.ICON_LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
L.ICON_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
L.esc = function (s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
};
L.money = function (cents) {
var format = CFG.moneyFormat || '${{amount}}';
cents = Math.round(Number(cents) || 0);
function delim(n, precision, thousands, decimal) {
var num = (n / 100).toFixed(precision).split('.');
var whole = num[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
return whole + (num[1] ? decimal + num[1] : '');
}
var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
var key = m ? m[1] : 'amount';
var val;
if (key === 'amount_no_decimals') val = delim(cents, 0, ',', '.');
else if (key === 'amount_with_comma_separator') val = delim(cents, 2, '.', ',');
else if (key === 'amount_no_decimals_with_comma_separator') val = delim(cents, 0, '.', ',');
else if (key === 'amount_with_apostrophe_separator') val = delim(cents, 2, "'", '.');
else val = delim(cents, 2, ',', '.');
var out = format.replace(/\{\{\s*\w+\s*\}\}/, val);
var tmp = document.createElement('div');
tmp.innerHTML = out;
return L.esc(tmp.textContent || out);
};
L.sized = function (url, w) {
if (!url) return '';
return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
};
L.api = function (path, body) {
var opts = { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
if (body) {
opts.method = 'POST';
if (body instanceof FormData) {
opts.body = body;
} else {
opts.headers['Content-Type'] = 'application/json';
opts.body = JSON.stringify(body);
}
}
return fetch(L.ROOT + path, opts).then(function (r) {
return r.json().then(function (j) {
if (!r.ok || j.status) {
var err = new Error(j.description || j.message || 'Error');
err.data = j;
throw err;
}
return j;
});
});
};
L.applyTheme = function (root) {
var map = { accent: '--cc-accent', btnBg: '--cc-btn-bg', btnText: '--cc-btn-text', badge1: '--cc-b1', badge2: '--cc-b2', badge3: '--cc-b3', radio: '--cc-radio', save: '--cc-save', barBg: '--cc-bar-bg', barColor: '--cc-bar-text', timerBg: '--cc-timer-bg', timerColor: '--cc-timer-text' };
Object.keys(map).forEach(function (k) {
if (typeof UI[k] === 'string' && /^[#a-zA-Z0-9(),.%\s-]+$/.test(UI[k])) root.style.setProperty(map[k], UI[k]);
});
};
L.topHTML = function () {
var h = '';
var bar = L.T('barText', '');
if (bar) h += '<div class="cc-bar">' + L.esc(bar) + '</div>';
if (L.on('timerOn', false)) h += '<div class="cc-timer" data-cc-timer></div>';
return h;
};
L.itemsTitleHTML = function () {
return L.on('showItemsTitle', true) ? '<div class="cc-items-title">' + L.esc(L.T('itemsTitle', 'Tus artículos elegidos')) + '</div>' : '';
};
L.tierCalc = function (data, n, vs) {
var type = n === 1 ? 'pct' : (data['k' + n] || 'pct');
var val = n === 1 ? 0 : Number(type === 'pct' ? data['d' + n] : data['m' + n]) || 0;
var base = 0, price = 0;
vs.forEach(function (v) { base += v.price; price += v.price - (type === 'pct' ? Math.floor(v.price * val / 100) : 0); });
if (type === 'monto') price = Math.max(0, base - Math.round(val * 100));
if (type === 'precio') price = Math.max(0, base - Math.max(0, n * data.variants[0].price - Math.round(val * 100)));
return { base: base, price: price, save: base - price, active: n === 1 || (val > 0 && price < base), label: type === 'pct' ? val + '%' : L.money(base - price) };
};
L.nudgeHTML = function (n, label, saveMoney) {
var txt = L.esc(L.T('nudgeText', '¡Agrega 1 más y ahorra {descuento} en tu pedido!')).replace(/\{descuento\}/gi, label).replace(/\{ahorro\}/gi, saveMoney);
return '<button type="button" class="cc-nudge" data-cc-tier="' + n + '"><span class="cc-nudge__ic">+1</span><span class="cc-nudge__tx">' + txt + '</span><span class="cc-nudge__go">' + L.esc(L.T('nudgeButton', 'Agregar')) + '</span></button>';
};
L.trustHTML = function () {
var t = L.T('trustText', '');
return t ? '<div class="cc-trust">' + L.esc(t) + '</div>' : '';
};
L.protId = function () { return L.on('protOn', false) ? Number(UI.protVariant) || 0 : 0; };
L.isProt = function (i) { var id = L.protId(); return !!id && i.variant_id === id; };
L.notProt = function (i) { return !L.isProt(i); };
L.protOff = function (v) {
try { if (v != null) sessionStorage.setItem('cc-prot-off', v ? '1' : '0'); return sessionStorage.getItem('cc-prot-off') === '1'; } catch (e) { return false; }
};
L.protEnsure = function (cart) {
var id = L.protId();
if (!id) return Promise.resolve(cart);
var lines = cart.items.filter(L.isProt), others = cart.items.some(L.notProt);
if (lines.length && !others) return L.api('cart/change.js', { id: String(id), quantity: 0 });
if (!lines.length && others && !L.protOff() && L.on('protAuto', true)) {
return L.api('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function () { return L.api('cart.js'); }).catch(function () { return cart; });
}
if (lines.length && lines[0].quantity > 1) return L.api('cart/change.js', { id: lines[0].key, quantity: 1 });
return Promise.resolve(cart);
};
L.protToggle = function (cart) {
var id = L.protId(), has = cart.items.some(L.isProt);
L.protOff(has);
return has ? L.api('cart/change.js', { id: String(id), quantity: 0 }) : L.api('cart/add.js', { items: [{ id: id, quantity: 1 }] });
};
L.protHTML = function (cart) {
if (!L.protId()) return '';
var on = cart.items.some(L.isProt);
var shield = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6l8-3z"/><path d="M9 12l2 2 4-4"/></svg>';
return '<div class="cc-prot' + (on ? ' is-on' : '') + '" role="switch" aria-checked="' + on + '" tabindex="0" data-cc-prot>' +
'<span class="cc-prot__ic">' + shield + '</span>' +
'<span class="cc-prot__tx"><b>' + L.esc(L.T('protTitle', 'Protección de envío')) + ' · ' + L.money(UI.protPrice || 0) + '</b>' +
'<span>' + L.esc(L.T('protText', 'Protege tu pedido contra pérdida, robo o daños')) + '</span></span>' +
'<span class="cc-prot__sw" aria-hidden="true"></span></div>';
};
var timerId = null;
L.startTimer = function (root) {
var el = root.querySelector('[data-cc-timer]');
if (!el) return;
var mins = Math.max(1, Number(UI.timerMinutes) || 10);
var end = 0;
try { end = Number(sessionStorage.getItem('cc-timer-end')) || 0; } catch (e) {}
function tick() {
var left = end - Date.now();
if (left <= 0) {
end = Date.now() + mins * 60000;
try { sessionStorage.setItem('cc-timer-end', String(end)); } catch (e) {}
left = end - Date.now();
}
var s = Math.floor(left / 1000), mm = Math.floor(s / 60), ss = s % 60;
var t = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
el.innerHTML = L.ICON_CLOCK + '<span>' + L.esc(L.T('timerText', 'Tu oferta está reservada por {tiempo}')).replace(/\{tiempo\}/gi, '<b>' + t + '</b>') + '</span>';
}
tick();
if (timerId) clearInterval(timerId);
timerId = setInterval(tick, 1000);
};
})();